import React, { useState } from 'react';
import { AppProvider } from './contexts/AppContext';
import { Sidebar } from './components/Layout/Sidebar';
import { ContentList } from './components/Content/ContentList';
import { BookForm } from './components/Books/BookForm';
import { SectionForm } from './components/Books/SectionForm';
import { useApp } from './contexts/AppContext';
import './App.css';

type ViewType = 'content' | 'add-book' | 'add-section';

interface AppContentProps {
  // Empty for now
}

const AppContent: React.FC<AppContentProps> = () => {
  const { books } = useApp();
  const [currentView, setCurrentView] = useState<ViewType>('content');
  const [selectedBookId, setSelectedBookId] = useState<string>('');

  const handleShowAddBook = () => {
    setCurrentView('add-book');
  };

  const handleShowAddSection = (bookId: string) => {
    setSelectedBookId(bookId);
    setCurrentView('add-section');
  };

  const handleCancel = () => {
    setCurrentView('content');
  };

  const selectedBook = books.find(b => b.id === selectedBookId);

  return (
    <div className="app-container">
      <Sidebar 
        onShowAddBook={handleShowAddBook}
        onShowAddSection={handleShowAddSection}
      />
      <div className="main-content">
        {currentView === 'content' && <ContentList />}
        {currentView === 'add-book' && <BookForm onCancel={handleCancel} />}
        {currentView === 'add-section' && selectedBook && (
          <SectionForm 
            bookId={selectedBookId}
            bookTitle={selectedBook.title}
            onCancel={handleCancel}
          />
        )}
      </div>
    </div>
  );
};

function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}

export default App;